import React from "react";
import { Field } from "react-final-form";
import { SelectInput } from "../../../components/inputs/final_form/SelectInput";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { SPECIALIES } from "../../../util/data/specialities";
import { objectToOptions } from "../../../util/formatters";
import { required } from "../../../util/validators";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";
import { SITE_OF_SERVICE_OPTIONS } from "../BenefitPullTypePage";

export const BenefitPullTypeForm = ({ handleSubmit, submitting, ...rest }) => {
  return (
    <>
      <Field
        component={SelectInput}
        label="Site of Service"
        options={SITE_OF_SERVICE_OPTIONS}
        name="siteOfService"
        required
        validate={required}
      />
      <Field
        component={AdministrateSelectInput}
        resourceUrl={`/admin/tests.json?test[direction]=asc&test[order]=commercial_name&archived=false`}
        label="Product/Procedure/Test"
        labelKey="commercial_name"
        name="testId"
        valueKey="id"
        key="test"
        validate={required}
      />
      <Field
        component={AdminOptionableInput}
        resource="payors"
        queryParams={{ payor: { order: "name", direction: "asc", archived: false } }}
        label="Payor"
        name="payorIds"
        isMulti
        key="payor"
      />
      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/cpt_codes.json"
        label="Procedure Codes"
        name="cptCodeIds"
        isMulti
        valueKey="id"
        validate={required}
      />
      <Field
        component={SelectInput}
        options={objectToOptions(SPECIALIES)}
        label="Provider Speciality"
        name="providerSpeciality"
        validate={required}
      />
      <Field component={TextInput} label="Practice Type Code" name="practiceTypeCode" validate={required} />
      <Field component={TextInput} label="Practice Type Object" name="practiceTypeObject" validate={required} />
      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting} validate={required}>
        Submit
      </LoadingButton>
    </>
  );
};
